import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-service.uat.onyxcentersource.com',
  hostname: 'pioneer.uat.onyxcentersource.com',
  portalUrl: 'https://portal.uat.onyxcentersource.com',
  onyxCommonDataUrl: 'https://ocd-service.uat.onyxcentersource.com/api',
  emailValidation: true
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/environments/environment.uat.ts